module.exports = __webpack_public_path__ + "static/the_big_event_photography_customer_story_thumbnail-9ce661d265bde9fef4b5aa227916ca36.png";